import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";

import styles from "./Transaction.m.scss";

function TransactionHeader(props) {
  const { theme } = props;

  return (
    <div className={classnames(theme.header)}>
      <div>{"Id"}</div>
      <div>{"Платежная система"}</div>
      <div>{"pan"}</div>
      <div>{"Код авторизации"}</div>
      {/* <div>{"Дата из терминала"}</div> */}
      <div>{"Дата обработки"}</div>
      <div>{"Суммы"}</div>
    </div>
  );
}

TransactionHeader.displayName = "TransactionHeader";

TransactionHeader.propTypes = {
  theme: PropTypes.object,
};

TransactionHeader.defaultProps = {};

export default themr("@lifepay/TransactionHeader", styles)(TransactionHeader);



// WEBPACK FOOTER //
// ./src/components/list-items/Transaction/Header.js